const EmbeddedRecording = () => import(/* webpackChunkName: "embedded" */ '@/components/embedded/recording/embedded-recording');
const EmbeddedRecordingRegistration = () => import(/* webpackChunkName: "embedded" */ '@/components/embedded/recording/embedded-recording-registration');
const RecordingViewer = () => import(/* wepackChunkName: "embedded" */ '@/components/recording/recording-viewer');
const Disclaimer = () => import(/* wepackChunkName: "disclaimer" */ '@/components/embedded/recording/disclaimer');

export default {
  path: 'embedded/recording',
  component: EmbeddedRecording,
  props: true,
  children: [
    {
      path: 'disclaimer',
      name: 'disclaimer',
      component: Disclaimer,
      props: true
    },
    {
      // embedded/recording/:embeddedResourceId
      path: ':embeddedResourceId',
      name: 'embedded-recording-registration',
      component: EmbeddedRecordingRegistration,
      props: true
    },
    {
      // embedded/recording/:recordingKey/view/:registrantKey
      path: ':recordingKey/view/:registrantKey',
      name: 'embedded-recording-view',
      component: RecordingViewer,
      props: (route) => ({
        recordingKey: route.params.recordingKey,
        registrantKey: route.params.registrantKey,
        controlsPlayback: route.params.controlsPlayback
      })
    }
  ]
};
